/**
 * Session filter: session properties (direct session columns), user properties, and event name.
 * Same data types and operators as Events/Transactions (string, number, boolean, datetime).
 */

// Session fields – same types as Events: string, number, boolean, datetime
export const getSessionProperties = () => [
  { name: 'country', label: 'Country', type: 'string', source: 'session' },
  { name: 'city', label: 'City', type: 'string', source: 'session' },
  { name: 'pages', label: 'Pages', type: 'string', source: 'session' },
  { name: 'entryPage', label: 'Entry Page', type: 'string', source: 'session' },
  { name: 'exitPage', label: 'Exit Page', type: 'string', source: 'session' },
  { name: 'browser', label: 'Browser', type: 'string', source: 'session' },
  { name: 'operatingSystem', label: 'Operating System', type: 'string', source: 'session' },
  { name: 'deviceType', label: 'Device Type', type: 'string', source: 'session' },
  { name: 'referrer', label: 'Referrer', type: 'string', source: 'session' },
  { name: 'isWeb3User', label: 'Is Web3 User', type: 'boolean', source: 'session' },
  { name: 'walletConnected', label: 'Wallet Connected', type: 'boolean', source: 'session' },
  { name: 'isBounce', label: 'Is Bounce', type: 'boolean', source: 'session' },
  { name: 'startTime', label: 'Session Start Time', type: 'datetime', source: 'session' },
  { name: 'pagesViewed', label: 'Pages Viewed', type: 'number', source: 'session' },
  { name: 'duration', label: 'Visit Duration (seconds)', type: 'number', source: 'session' },
  { name: 'visitsByUser', label: 'Number of Visits by User', type: 'number', source: 'session' }
];

// Event properties for sessions: only event name
export const getSessionEventProperties = () => [
  { name: 'event_name', label: 'Event name', type: 'string', source: 'event' }
];

// User properties – same as transaction/events global
export { getUserPropertiesForTransaction as getSessionUserProperties } from './transactionFilterProperties';

// Operators – same as Events/Transactions (use from transactionFilterProperties)
export {
  getOperatorsForTransactionType as getSessionOperatorsForType,
  getDefaultOperator as getDefaultSessionOperator
} from './transactionFilterProperties';
